import { Outlet, Navigate, useSearchParams, useNavigate } from "react-router-dom";
import useLogin from "../hooks/useLogin";
// import Header from "../components/organism/Header";
import Footer from "../components/organism/Footer";
import { useSelector } from "react-redux";
import Layout from "../components/pages/Layout";
// import TagManager from "react-gtm-module";
import TagManager from "react-gtm-module";
import { getGTMId } from "./analytics";
import { useEffect } from "react";
import { constants } from "../constants";
import { getCookie } from "../utilities/cookieUtilities.js";
import { checkSSOStatus } from "../utilities/cookieUtilities.js";
import { PageLoaderNew } from "../components/atoms/Loader/index.js";


export const PrivateRoutes =(props)=>{
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { persistItemsReducer } = useSelector((state) => state);
    const [active, accessToken, getAccessToken] = useLogin();
    const { getCookiePreferenceReducer } = useSelector((state) => state);   
    const cookiesPreferenceEnabled = getCookiePreferenceReducer?.getCookiePreference?.cookiesPreferenceEnabled;
    const ssoCookie = getCookie(constants?.so_NZLO?.nzSSOCookieName);
    const subdirectory = (window.location.origin.includes(".nz") ||
    window.location.origin.includes(".at") ||
    window.location.origin.includes(".fi") || 
    window.location.origin.includes("stgjpn")) ? "" : persistItemsReducer?.selectedSOData?.soCode?.toLowerCase();
     if(active === accessToken){console.log("true")}
    initGTM(cookiesPreferenceEnabled);

    // SSO loader takes priority for all routes
    if (ssoCookie && !checkSSOStatus()) {
        return (
            <div style={{ height: "100vh" }}>
                <PageLoaderNew>
                    <div className="spinner--wv-star">
                        <div className="double-bounce1"></div>
                        <div className="double-bounce2"></div>
                    </div>
                </PageLoaderNew>
            </div>
        );
    }

    if(props?.home){
        return(


            //active ? <Navigate to="/home" /> :<Outlet />    
            getAccessToken() && getAccessToken() !== ""  ? <><Outlet /><Footer/></> : setTimeout(()=><Navigate to="/" />,500)    
           )
    }
    else{
         
         if (!accessToken || accessToken === "" || accessToken === undefined && !active) { 
            if (searchParams.get("redirect_url")) {
                console.log("inside route 1")
                localStorage.setItem("redirectVia", "redirect_url")
                navigate(`/${subdirectory}?redirect_url=${searchParams.get("redirect_url")}`)
              } else {
                if (searchParams.get("soname") && searchParams.get("soname") != "undefined") {
                    console.log("inside route 2")
                  localStorage.setItem("pathname", window.location.pathname)
                  localStorage.setItem("search", window.location.search)
                  localStorage.setItem("soname", searchParams.get("soname"))
                  navigate(`/${searchParams.get("soname")}`)
                }
                else {
                  navigate("/")
                }
              }
            return (
            <div style={{ height: "100vh" }}>
                
                <PageLoaderNew>
                    <div className="spinner--wv-star">
                        <div className="double-bounce1"></div>
                        <div className="double-bounce2"></div>
                    </div>
                </PageLoaderNew>
            </div>
        );
       }
        
        return( 
            getAccessToken() && getAccessToken() !== ""  ? <><Layout/><Outlet /> <Footer/></> : setTimeout(()=><Navigate to="/" />,500)    
           ) 
    }
}

export const PublicRoutes =()=>{
    const [active, accessToken, getAccessToken] = useLogin();   
    if(active === accessToken){console.log("true")}

    initGTM();
    const { persistItemsReducer } = useSelector((state) => state);
    return(
        getAccessToken() && getAccessToken() !== "" ? (<Navigate to={persistItemsReducer.saveAuthParams.navURL?persistItemsReducer.saveAuthParams.navURL:"/home"} /> ):<Outlet />    
     // active ? <Outlet /> : <Navigate to="/" />     
    )
}

export const PublicRoutes2 =()=>{
    const { persistItemsReducer } = useSelector((state) => state);
    const [searchParams] = useSearchParams();

    if( (window.location.pathname.includes("/nzlo") || window.location.hostname.includes(".nz"))
    && searchParams?.get("action") 
    && searchParams?.get("action") === "logout"
    && !document?.referrer?.includes(window.location.hostname)){
        const logoutURL = constants?.postLogoutUrl+ "nzlo";
        window.location.replace(logoutURL);
        localStorage.removeItem("tokenResp");
        localStorage.removeItem("persist:root");
        localStorage.removeItem ("ssoCompleted");
    }    

    const [active, accessToken, getAccessToken] = useLogin();   
    if(active === accessToken){console.log("true")}

    initGTM();
    return(
        getAccessToken() && getAccessToken() !== "" ? (<Navigate to={persistItemsReducer.saveAuthParams.navURL?persistItemsReducer.saveAuthParams.navURL:"/home"} /> ): <><Outlet /> <Footer/></>   
    )
}
export const PublicRoutes3 =()=>{
    return(
        <><Layout/><Outlet /> <Footer/></>
    )
}
const initGTM = (cookiesPreferenceEnabled = true)=>{
    const { persistItemsReducer } = useSelector((state) => state); 
    useEffect(()=>{        
    const soName  = persistItemsReducer?.selectedSOData?.soCode?.toLowerCase();
    if(cookiesPreferenceEnabled){
    const tagManagerArgs = {
        gtmId : getGTMId(soName)
     }
     soName && TagManager.initialize(tagManagerArgs);
    }

    },[persistItemsReducer?.selectedSOData?.soCode])
}